var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardDec1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.482,
    height: 15.482,
    viewBox: "0 0 15.482 15.482",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.29;}.b{fill:none;stroke:#366aaf;stroke-miterlimit:10;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(-1946.431 -1814.425) rotate(45)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2670.274 -102.789)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "b",
    y2: 6.686
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    y2: 6.686,
    transform: "translate(0 12.209)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2660.827 -93.342)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 6.686,
    transform: "translate(12.209)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 6.686
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardDec1);
export default __webpack_public_path__ + "static/media/CardDec1.640f38747434b321f253ba5b73b4157b.svg";
export { ForwardRef as ReactComponent };